import { render, staticRenderFns } from "./zone-in-country-areas.vue?vue&type=template&id=206e2c48"
import script from "./zone-in-country-areas.vue?vue&type=script&lang=js"
export * from "./zone-in-country-areas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports